export const GTAG_EVENT = 'event'

export function gtag(...args) {
  if (typeof window !== 'undefined' && window.gtag) window.gtag(...args)
}
